import React from "react";
import PageHero from "./components/PageHero";
import Specialties from "./components/Specialties";
import Differentials from "./components/Differentials";
import CTA from "./components/CTA";

export default function Servicos() {
  return (
    <main className="servicos">
      <PageHero
        eyebrow="Eniato Contabilidade"
        title={
          <>
            Contabilidade{" "}
            <strong className="page-hero__title-highlight">Estratégica</strong>{" "}
            para o Crescimento de Factoring e Securitizadora de Créditos.
          </>
        }
        text="Soluções completas nas áreas Fiscal, Legal e Contábil para manter sua empresa organizada, regularizada e preparada para crescer."
        primaryButton={{ label: "Solicitar Proposta", to: "/contato" }}
        secondaryButton={{ label: "Conheça Nossos Pilares", href: "#especialidades" }}
      />

      <Specialties />
      <Differentials />

      <CTA variant="centered" />
    </main>
  );
}
